export function nextGraphSelection(previous: string[], nodeId: string): string[] {
  if (previous.length === 1 && previous[0] !== nodeId) return [previous[0], nodeId]
  return [nodeId]
}
